import { ConfigProvider } from "antd";
import { ReactNode } from "react";
import { createStyledBreakpointsTheme } from "styled-breakpoints";
import { ThemeProvider } from "styled-components";
import { useApp } from "./AppProvider";

export const breakpoints = {
  sm: "0px",
  xs: "450px",
  md: "640px",
  mm: "768px",
  lg: "1024px",
  xl: "1200px",
  xxl: "1440px",
} as const;

export const defaultTheme = {
  ...createStyledBreakpointsTheme({ breakpoints }),
};

export const Theme = ({ children }: { children: ReactNode }) => {
  const { mainColor } = useApp();

  return (
    <ConfigProvider theme={{ token: { colorPrimary: mainColor } }}>
      <ThemeProvider theme={defaultTheme}>{children}</ThemeProvider>
    </ConfigProvider>
  );
};
